<template>
  <div class="npa-link-list">
    <div class="npa-link-item" v-for="npa in npas" :key="npa.id">
      <div class="npa-link-head">
        <div class="date">
          {{ new Date(npa.publish_date) | dateFormat('DD.MM.YYYY') }}
        </div>
        <div class="analytics">
        <span class="views">
          <i class="pro-icon-eye"></i>{{ npa.view_number }}
        </span>
          <span class="comments">
          <i class="pro-icon-chat"></i>
          {{commentsCnt[npa.id].cntComments }}
        </span>
          <span class="messages">
          <i class="pro-icon-speech-bubble"></i>
          {{ answersCnt[npa.id].cntAnswers }}
        </span>
        </div>
      </div>
      <router-link
        tag="a"
        :title="npa.transProjectGoal | strippedContent"
        :to="$i18nRoute({ name: 'view-npa', params: { id: npa.id } })"
        :key="npa.id"
      >
        {{ npa.transName | splitTextIntoLines(2, 40) }}
      </router-link>
      <div class="npa-link-list-developer">
        {{ $t('Разработчик') }}:
        <v-icon
          v-if="npa.developer.status === false"
          class="nv_icon mr-1"
          x-small
        />
        {{ npa.developer.transName }}
      </div>
      <div class="npa-link-list-developer">
        {{ $t('Срок обсуждения') }}:
        {{ npa.days_remaining_between }} {{$t('дней')}}
      </div>
    </div>
  </div>
</template>

<script>
import CMS from '@/model/cms'

export default {
  props: {
    widget: Object
  },
  data: () => ({
    npas: [],
    commentsCnt: [],
    answersCnt: []
  }),
  mounted() {
    CMS.getNpa(this.widget.type, 3)
      .then((response) => {
        this.npas = response.data.npas
        this.commentsCnt = response.data.commentsCnt
        this.answersCnt = response.data.answersCnt
      })
      .catch((error) => {
        //@todo ошибки
      })
  }
}
</script>
